<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>

export default {
  name: 'App',
};
</script>

<style>
.feather {
  width: 16px;
  height: 16px;
  vertical-align: text-bottom;
  margin-bottom: 2px;
}
</style>
